import fp from 'lodash/fp';

export const parseInt = fp.parseInt(10);

export const toKeyValue = (key, value) =>
  fp.flow(fp.keyBy(key), fp.mapValues(value));
